import React from 'react'
import { Menu, MenuItem } from '@blueprintjs/core'
import { IGridTableColumn, Skeleton, IconButton, Popover } from '@ui'
import { IBooking, RecurrencePatternType, getRecurrencePatternType } from '@api'
import css from './bookingsTeamsTab.module.scss'
import CheckInButton from 'components/CheckInButton/CheckInButton'
import { DateUtil } from '../../utils/dateUtil'

type GetBookingColumns = (params: {
  cancelBooking: (bookingId: string | undefined) => void
}) => IGridTableColumn<IBooking>[]

const createBookingColumns: GetBookingColumns = ({ cancelBooking }) => [
  {
    label: 'When',
    sort: 'startDate',
    colSpan: 2,
    Cell: ({ skeleton, cell }) => {
      if (!cell || !cell.data) return null
      const timezone = cell?.data.space.floor.building?.timezone ?? ''
      const start = DateUtil.utc(cell?.data?.startDate, timezone)
      const end = DateUtil.utc(cell?.data?.endDate, timezone)
      return skeleton ? (
        <Skeleton withButton />
      ) : (
        <div data-test="bookings_date" className="flex flex-row">
          <div className="font-light">
            {start.format('MMMM dd, yyyy')} from {start.format('hh:mma')} to {end.format('hh:mma')}
          </div>
        </div>
      )
    },
  },
  {
    label: 'Name',
    sort: 'space.externalId',
    colSpan: 1,
    Cell: ({ skeleton, cell }) =>
      skeleton ? <Skeleton /> : <div className="font-light">{cell?.data.space.externalId}</div>,
  },
  {
    label: 'Location',
    colSpan: 3,
    Cell: ({ skeleton, cell }) =>
      skeleton ? (
        <Skeleton />
      ) : (
        <div data-test="bookings_location" className="flex flex-col">
          <div className="font-light">
            {cell?.data.space.floor.building?.address} {cell?.data.space.floor.building?.city}
          </div>
        </div>
      ),
  },
  {
    label: 'Type',
    colSpan: 1,
    Cell: ({ skeleton, cell }) =>
      skeleton ? (
        <Skeleton />
      ) : (
        <div className="font-light">
          {getRecurrencePatternType(cell?.data.bookingSchedule?.recurrencePattern)}
        </div>
      ),
  },
  {
    label: '',
    colSpan: 1,
    alignRight: true,
    cellStyle: {
      paddingRight: 20,
    },
    Cell: ({ skeleton, cell }) =>
      skeleton ? (
        <Skeleton />
      ) : (
        <Popover
          popoverClassName={css.actions_wrapper}
          content={
            <Menu>
              <MenuItem
                style={{ marginBottom: 2 }}
                text={
                  <CheckInButton
                    booking={cell?.data}
                    classStyle={{
                      checkedIn: css.checkedInBtnClass,
                      disabled: css.disabledBtnClass,
                      checkIn: css.checkInBtnClass,
                    }}
                  />
                }
              />
              <MenuItem text="Cancel Booking" onClick={() => cancelBooking(cell?.data.id)} />
            </Menu>
          }
        >
          <IconButton className={css.ellipsis_button} round={false} iconName="ellipsis-h" />
        </Popover>
      ),
  },
]

export default createBookingColumns
